import type { ReactNode } from 'react';

export function PageHeader({
    title,
    center,
    value,
    color,
}: {
    title: ReactNode;
    center?: ReactNode;
    value?: ReactNode;
    color?: string;
}) {
    return (
        <div>
            <div className='flex flex-wrap items-center justify-between px-4 py-2 text-xl font-medium sm:text-2xl'>
                <div>{title}</div>
                <div>{center}</div>
                <div>{value}</div>
            </div>

            <div className='border-b-4 border-b-primary' style={{ borderBottomColor: color }} />
        </div>
    );
}
